import Vue from 'vue'
import VueRouter from 'vue-router'
import Head from '@/views/Head.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'head',
    component: Head
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
